module.exports = __webpack_public_path__ + "fonts/sk_icons.7953da2.eot";